class IntegratedWaitlistPopup {
  constructor() {
    this.KLAVIYO_PUBLIC_KEY = 'VJzX4x';
    this.CLIENT_API_BASE = 'https://a.klaviyo.com/client';
    this.WAITLIST_ID = 'YAAdKa';
    this.RETRY_QUEUE_KEY = 'wl_retry_queue';
    this.MAX_RETRIES = 3;

    this.modal = null;
    this.form = null;
    this.emailInput = null;
    this.nameInput = null;
    this.gdprCheckbox = null;
    this.submitBtn = null;
    this.priceElement = null;
    this.productData = null;
    this.currentVariantData = null;

    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
  this.modal = document.querySelector('[data-wl-modal]');
  if (!this.modal) return;

  this.mountToPortal();
  this.form = this.modal.querySelector('[data-wl-form]');
  this.emailInput = this.modal.querySelector('#minimal-wl-email');
  this.nameInput = this.modal.querySelector('#minimal-wl-name');
  this.submitBtn = this.modal.querySelector('.minimal-wl-submit-btn');
  this.priceElement = this.modal.querySelector('[data-wl-price]');

  this.loadProductData();
  this.bindEvents();
  this.setupFormValidation();
  this.flushQueue();
  this.syncWithUpsell();
}

  mountToPortal() {
    const portalRoot = document.getElementById('modal-root');
    const target = portalRoot || document.body;
    if (this.modal.parentElement !== target) {
      target.appendChild(this.modal);
    }
  }

  loadProductData() {
    const dataScript = document.querySelector('[data-wl-product]');
    if (!dataScript) return;
    
    try {
      this.productData = JSON.parse(dataScript.textContent.trim());
      this.updateCurrentVariant();
    } catch (e) {
      console.error('Failed to parse product data:', e);
    }
  }

  formatPrice(priceInCents) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(priceInCents / 100);
  }

  updateCurrentVariant() {
    if (!this.productData) return;

    const urlParams = new URLSearchParams(window.location.search);
    const currentVariantId = urlParams.get('variant') || this.productData.variant_id;
    
    let selectedVariant = this.productData.variants.find(v => v.id == currentVariantId);
    if (!selectedVariant) {
      selectedVariant = this.productData.variants.find(v => v.available) || this.productData.variants[0];
    }

    this.currentVariantData = {
      ...selectedVariant,
      product_title: this.productData.title,
      product_handle: this.productData.handle,
      product_id: this.productData.product_id,
      product_url: this.productData.url,
      product_image: this.productData.image,
      product_vendor: this.productData.vendor,
      product_type: this.productData.type
    };

    const upsellCheckbox = document.querySelector('.finish-input');
    const isUpsellSelected = upsellCheckbox && upsellCheckbox.checked;
    
    if (isUpsellSelected && this.productData.upsell) {
      this.currentVariantData.has_upsell = true;
      this.currentVariantData.upsell_variant_id = this.productData.upsell.variant_id;
      this.currentVariantData.upsell_price = this.productData.upsell.price;
      this.currentVariantData.upsell_title = this.productData.upsell.title;
      this.currentVariantData.upsell_price_difference = this.productData.upsell.price_difference;
      this.currentVariantData.total_price = this.productData.upsell.price;
      this.currentVariantData.formatted_price = this.formatPrice(this.productData.upsell.price);
    } else {
      this.currentVariantData.has_upsell = false;
      this.currentVariantData.total_price = selectedVariant.price;
      this.currentVariantData.formatted_price = this.formatPrice(selectedVariant.price);
    }

    if (this.priceElement) {
      this.priceElement.textContent = this.currentVariantData.formatted_price;
    }
  }

  syncWithUpsell() {
    document.addEventListener('change', (e) => {
      if (e.target.matches('.finish-input')) {
        this.updateCurrentVariant();
      }
    });

    document.addEventListener('variant:change', () => {
      this.updateCurrentVariant();
    });

    document.addEventListener('variant:changed', () => {
      this.updateCurrentVariant();
    });
  }

  setOpenState(isOpen) {
    if (!this.modal) return;
    
    this.modal.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    document.body.style.overflow = isOpen ? 'hidden' : '';
    
    if (isOpen) {
      this.modal.style.display = 'flex';
      setTimeout(() => {
        this.modal.classList.add('show');
      }, 10);
    } else {
      this.modal.classList.remove('show');
      setTimeout(() => {
        this.modal.style.display = 'none';
      }, 200);
    }
  }

  bindEvents() {
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-wl-open]') || e.target.closest('[data-wl-open]')) {
        e.preventDefault();
        this.openModal();
      }
    });

    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-wl-close]') || e.target.closest('[data-wl-close]')) {
        e.preventDefault();
        this.closeModal();
      }
    });

    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) {
        this.closeModal();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.getAttribute('aria-hidden') === 'false') {
        this.closeModal();
      }
    });

    if (this.form) {
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.handleSubmit();
      });
    }

    window.addEventListener('online', () => this.flushQueue());
  }

setupFormValidation() {
  if (!this.emailInput || !this.submitBtn) return;

  const validateForm = () => {
    const email = this.emailInput.value.trim();
    this.submitBtn.disabled = !(email.length > 0);
  };

  this.emailInput.addEventListener('input', validateForm);
  validateForm();
}

  openModal() {
    if (!this.modal) return;
    this.updateCurrentVariant();
    this.resetForm();
    this.setOpenState(true);
    setTimeout(() => this.emailInput?.focus(), 100);
  }

  closeModal() {
    if (!this.modal) return;
    this.setOpenState(false);
  }

  isValidEmail(email) {
    const basicPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!basicPattern.test(email)) return false;
    
    const parts = email.split('@');
    if (parts.length !== 2) return false;
    
    const [localPart, domain] = parts;
    if (localPart.length === 0 || domain.length === 0) return false;
    
    const domainParts = domain.split('.');
    if (domainParts.length < 2) return false;
    
    const tld = domainParts[domainParts.length - 1];
    if (tld.length < 2 || tld.length > 6) return false;
    
    if (domain.includes('..') || domain.startsWith('.') || domain.endsWith('.')) return false;
    
    const validTlds = [
      'com', 'org', 'net', 'edu', 'gov', 'mil', 'int', 'co', 'uk', 'de', 
      'fr', 'it', 'es', 'ru', 'jp', 'cn', 'au', 'ca', 'br', 'mx', 'pl',
      'nl', 'be', 'ch', 'at', 'se', 'dk', 'no', 'fi', 'cz', 'hu', 'pt',
      'ie', 'gr', 'bg', 'ro', 'sk', 'si', 'hr', 'ee', 'lv', 'lt', 'lu',
      'mt', 'cy', 'ua', 'by', 'md', 'info', 'biz', 'name', 'pro', 'travel',
      'jobs', 'mobi', 'tel', 'asia', 'cat', 'coop', 'museum', 'aero'
    ];
    
    if (!validTlds.includes(tld.toLowerCase())) return false;
    
    const invalidDomains = [
      'gmail.oom', 'gmail.co', 'gmail.ocm', 'gmail.cm', 'gmai.com', 'gmial.com',
      'gnail.com', 'gamil.com', 'gmaill.com', 'gmali.com', 'gmai.co',
      'yahoo.oom', 'yahoo.co', 'yahho.com', 'yaho.com', 'yahooo.com',
      'hotmail.oom', 'hotmail.co', 'hotmai.com', 'hotmial.com', 'hotmil.com',
      'outlook.oom', 'outlook.co', 'outlok.com', 'outloo.com', 'outlok.co'
    ];
    
    if (invalidDomains.includes(domain.toLowerCase())) return false;
    
    return true;
  }

  getEmailErrorMessage(email) {
    if (!email.includes('@')) {
      return 'Email must contain @';
    }
    
    const domain = email.split('@')[1];
    if (!domain) {
      return 'Invalid email address';
    }
    
    const domainLower = domain.toLowerCase();
    const suggestions = {
      'gmail.oom': 'gmail.com',
      'gmail.co': 'gmail.com',
      'gmail.ocm': 'gmail.com',
      'gmail.cm': 'gmail.com',
      'gmai.com': 'gmail.com',
      'gmial.com': 'gmail.com',
      'gnail.com': 'gmail.com',
      'gamil.com': 'gmail.com',
      'gmaill.com': 'gmail.com',
      'gmali.com': 'gmail.com',
      'gmai.co': 'gmail.com',
      'yahoo.oom': 'yahoo.com',
      'yahoo.co': 'yahoo.com',
      'yahho.com': 'yahoo.com',
      'yaho.com': 'yahoo.com',
      'yahooo.com': 'yahoo.com',
      'hotmail.oom': 'hotmail.com',
      'hotmail.co': 'hotmail.com',
      'hotmai.com': 'hotmail.com',
      'hotmial.com': 'hotmail.com',
      'hotmil.com': 'hotmail.com',
      'outlook.oom': 'outlook.com',
      'outlook.co': 'outlook.com',
      'outlok.com': 'outlook.com',
      'outloo.com': 'outlook.com',
      'outlok.co': 'outlook.com'
    };
    
    if (suggestions[domainLower]) {
      return `Did you mean ${suggestions[domainLower]}?`;
    }
    
    if (!domain.includes('.')) {
      return 'Email needs valid domain';
    }
    
    const tld = domain.split('.').pop();
    if (tld && (tld.length < 2 || tld.length > 6)) {
      return 'Invalid domain extension';
    }
    
    return 'Please enter a valid email address';
  }

  async handleSubmit() {
    if (!this.productData || !this.currentVariantData) return;

    const honeypot = this.form?.querySelector('[name="website"]');
    if (honeypot && honeypot.value) return;

    const email = this.emailInput.value.trim();
    const firstName = this.nameInput.value.trim() || '';
    const gdprConsent = true;

    if (!this.isValidEmail(email)) {
      this.showError('minimal-wl-email-error', this.getEmailErrorMessage(email));
      this.emailInput.classList.add('invalid');
      return;
    }
    
    if (!gdprConsent) {
      this.showError('minimal-wl-gdpr-error', 'Please agree to receive notifications');
      return;
    }

    this.setLoadingState(true);
    this.clearAllErrors();

    try {
      await this.subscribeToWaitlist(email, firstName, gdprConsent);
      this.showSuccess();
    } catch (error) {
      this.enqueueEvent(email, firstName, gdprConsent);
      this.showError('minimal-wl-submit-status', 'Connection issue. We saved your request.');
    } finally {
      this.setLoadingState(false);
    }
  }

  async klaviyoClientPost(path, payload) {
    const url = `https://a.klaviyo.com${path}?company_id=${this.KLAVIYO_PUBLIC_KEY}`;
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2025-07-15'
      },
      body: JSON.stringify(payload),
      credentials: 'omit',
      mode: 'cors'
    });
    
    if (!res.ok && res.status !== 202) {
      const text = await res.text().catch(() => '');
      throw new Error(`Klaviyo client POST failed: ${res.status} ${text}`);
    }
    
    return true;
  }

  async subscribeToWaitlist(email, firstName, gdprConsent) {
    const profileProperties = {
      waitlist_signup: true,
      last_waitlist_product: this.currentVariantData.product_title,
      product_id: String(this.currentVariantData.product_id),
      variant_id: String(this.currentVariantData.id),
      formatted_price: this.currentVariantData.formatted_price,
      has_upsell: this.currentVariantData.has_upsell,
      upsell_price_difference: this.currentVariantData.upsell_price_difference || 0,
      source: 'waitlist_modal'
    };

    const subscriptionPayload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Waitlist Modal',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                first_name: firstName || '',
                properties: profileProperties,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED' 
                    }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: this.WAITLIST_ID } }
        }
      }
    };

    try {
      await this.klaviyoClientPost('/client/subscriptions', subscriptionPayload);
    } catch (subscriptionError) {
      throw subscriptionError;
    }

    try {
      const eventPayload = {
        data: {
          type: 'event',
          attributes: {
            metric: { 
              data: { 
                type: 'metric', 
                attributes: { 
                  name: 'Joined Waitlist' 
                } 
              } 
            },
            properties: { 
              ...profileProperties, 
              list_id: this.WAITLIST_ID 
            },
            profile: { 
              data: { 
                type: 'profile', 
                attributes: { 
                  email, 
                  first_name: firstName || '' 
                } 
              } 
            }
          }
        }
      };

      await this.klaviyoClientPost('/client/events', eventPayload);
    } catch (eventError) {
      // Silent fail for events
    }

    if (window.klaviyo) {
      try {
        window.klaviyo.identify({ 
          $email: email, 
          $first_name: firstName, 
          ...profileProperties 
        });
        window.klaviyo.track('Joined Waitlist', { 
          ...profileProperties, 
          $email: email, 
          $first_name: firstName 
        });
      } catch (klaviyoError) {
        // Silent fail for JS tracking
      }
    }

    return { success: true };
  }

  enqueueEvent(email, firstName, gdprConsent) {
    try {
      const queue = this.getRetryQueue();
      queue.push({
        email,
        firstName,
        gdprConsent,
        variantData: this.currentVariantData,
        timestamp: Date.now(),
        retries: 0
      });
      localStorage.setItem(this.RETRY_QUEUE_KEY, JSON.stringify(queue));
    } catch (e) {
      // Silent fail for queue
    }
  }

  async flushQueue() {
    const queue = this.getRetryQueue();
    if (!queue.length) return;
    const processed = [];
    
    for (const event of queue) {
      if (event.retries >= this.MAX_RETRIES) {
        processed.push(event);
        continue;
      }
      
      try {
        const delay = Math.pow(2, event.retries) * 1000;
        if (Date.now() - event.timestamp < delay) continue;
        
        const originalVariant = this.currentVariantData;
        this.currentVariantData = event.variantData;
        
        await this.subscribeToWaitlist(event.email, event.firstName, event.gdprConsent);
        this.currentVariantData = originalVariant;
        processed.push(event);
      } catch (err) {
        event.retries++;
        event.timestamp = Date.now();
      }
    }
    
    const remaining = queue.filter(ev => !processed.includes(ev));
    localStorage.setItem(this.RETRY_QUEUE_KEY, JSON.stringify(remaining));
  }

  getRetryQueue() {
    try {
      const raw = localStorage.getItem(this.RETRY_QUEUE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  }

  setLoadingState(loading) {
    if (!this.submitBtn) return;
    this.submitBtn.disabled = loading;
    this.submitBtn.classList.toggle('loading', loading);
  }

  showSuccess() {
    const header = this.modal.querySelector('.minimal-wl-header');
    const form = this.modal.querySelector('.minimal-wl-form');
    const successMsg = this.modal.querySelector('#minimal-wl-success-message');
    const leftSide = this.modal.querySelector('.minimal-wl-left');
    
    if (header) header.style.display = 'none';
    if (form) form.style.display = 'none';
    if (leftSide) leftSide.style.display = 'none';
    
    if (successMsg) {
      successMsg.style.display = 'block';
      successMsg.querySelector('.minimal-wl-success-animation').classList.add('animate');
    }
    
    setTimeout(() => this.closeModal(), 4000);
  }

  showError(id, message) {
    const el = document.getElementById(id);
    if (el) el.textContent = message;
  }

  clearError(id) {
    const el = document.getElementById(id);
    if (el) el.textContent = '';
  }

  clearAllErrors() {
    this.modal.querySelectorAll('.minimal-wl-error').forEach(el => el.textContent = '');
    this.emailInput.classList.remove('invalid');
  }

  resetForm() {
    if (!this.form) return;
    
    this.form.reset();
    this.clearAllErrors();
    
    const header = this.modal.querySelector('.minimal-wl-header');
    const form = this.modal.querySelector('.minimal-wl-form');
    const leftSide = this.modal.querySelector('.minimal-wl-left');
    
    if (header) header.style.display = '';
    if (form) form.style.display = '';
    if (leftSide) leftSide.style.display = '';
    
    this.modal.querySelectorAll('.minimal-wl-message').forEach(msg => {
      msg.style.display = 'none';
      const animation = msg.querySelector('.minimal-wl-success-animation');
      if (animation) animation.classList.remove('animate');
    });
    
    this.setLoadingState(false);
    if (this.submitBtn) this.submitBtn.disabled = true;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new IntegratedWaitlistPopup();
});

if (document.readyState === 'complete') {
  new IntegratedWaitlistPopup();
}